import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  Grid,
  Typography,
} from "@mui/material";
import Swal from "sweetalert2";
import { useCreateMyGrapariUser } from "./hooks/useCreateMyGrapariUser";

const AddSubscriberDialog: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [msisdn, setMsisdn] = useState("");
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [osType, setOsType] = useState("");
  const [osVersion, setOsVersion] = useState("");
  const [brandError, setBrandError] = useState(false);
  const { createMyGrapariUserAsync } = useCreateMyGrapariUser();

  const handleSave = async () => {
    // Validate brand field
    if (brand.trim() === "") {
      setBrandError(true);
      return;
    }

    const fullMsisdn = "852" + msisdn;

    setOpen(false);

    const result = await Swal.fire({
      title: "Are you sure?",
      html: `
        <p>You are about to add a new subscriber</p>
        <b>MSISDN:</b> ${fullMsisdn}<br/>
        <b>Brand:</b> ${brand}<br/>
        <b>Model:</b> ${model}<br/>
        <b>OS:</b> ${osType} ${osVersion}
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, add it!",
    });

    if (result.isConfirmed) {
      try {
        const res = await createMyGrapariUserAsync({
          msisdn: fullMsisdn,
          device_info: {
            brand,
            model,
            os_type: osType,
            os_version: osVersion,
          },
        });

        console.log(7777777, res);

        await Swal.fire("Added!", `User created.`, "success");
      } catch (err: any) {
        await Swal.fire("Error", err.message, "error");
      }
    } else {
      setOpen(true);
    }
  };

  const isFormValid = brand.trim() !== "";

  return (
    <>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Add New Subscriber
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add new User</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="normal"
            label="MSISDN"
            value={msisdn}
            onChange={(e) => setMsisdn(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">852</InputAdornment>
              ),
            }}
          />

          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            Device Info
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                margin="normal"
                label="Brand"
                value={brand}
                onChange={(e) => {
                  setBrand(e.target.value);
                  setBrandError(false);
                }}
                required
                error={brandError}
                helperText={brandError ? "Brand is required" : ""}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                margin="normal"
                label="Model"
                value={model}
                onChange={(e) => setModel(e.target.value)}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                margin="normal"
                label="OS Type"
                value={osType}
                onChange={(e) => setOsType(e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                margin="normal"
                label="OS Version"
                value={osVersion}
                onChange={(e) => setOsVersion(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpen(false)}
            color="error"
            variant="contained"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            color="primary"
            variant="contained"
            disabled={!isFormValid}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddSubscriberDialog;
